const customAvtar = {
  flex: 1,
  justifyContent: "flex-start",
  "& .MuiAvatar-root": {
    width: 30,
    height: 30,
    fontSize: "small",
    border: "2px solid white",
    marginLeft: "-8px",
    zIndex: 1,
    "&:first-of-type": {
      marginLeft: 0,
    },
  },
};

const multiSelectStyles = {
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333",
    lineHeight: "normal",
    fontSize: "14px",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    fontSize: "14px",
  }),
  option: (provided) => ({
    ...provided,
    fontSize: "14px",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "14px",
  }),
};

const documentCardStyles = {
  marginBottom: "16px",
  padding: "12px",
  border: "1px solid lightgray",
  boxShadow: "0 .3rem 1.3rem rgba(0,0,0,.075)!important",
  borderRadius: "10px",
  backgroundColor: "#f3f5f7",
};

export const tablePaperStyle = { width: "100%", overflow: "hidden", boxShadow: "none" };
export const modalContainerStyle = {
  width: { xs: "90vw", sm: 430 },
  maxWidth: "90vw",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: 5,
};

export const customSelectPortalStyle = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "#ffffff",
    border: "1px solid #00000029",
    borderRadius: "8px",
    boxShadow: "none",
    minHeight: "64px",
    padding: "2px 0",
    cursor: "pointer",
    "&:hover": {
      borderColor: "#000",
      backgroundColor: "#f9f9f9"
    }
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "4px 14px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "#444",
    "&:hover": {
      color: "#000"
    }
  }),
  placeholder: (base) => ({
    ...base,
    margin: 0,
    color: "#a0aab5",
    fontSize: "15px"
  }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    overflow: "visible"
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "#222",
    fontSize: "15px"
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 })
}

// --------------------------------------------------------Image Cropper Styles-----------------------------------------------------

export const rotationDisplayStyle = {
  minWidth: "100px",
  textAlign: "center",
  px: 2,
  py: 0.5,
  backgroundColor: "white",
  borderRadius: "8px",
  border: "2px solid #e0e0e0",
};

export const cropContainerStyle = {
  border: "2px solid #e0e0e0",
  borderRadius: "12px",
  padding: 2,
  backgroundColor: "#f5f5f5",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: 300,
  maxHeight: "60vh",
  overflow: "auto",
};

export const cropSourceStyle = (rotation) => ({
  maxWidth: "100%",
  height: "auto",
  display: "block",
  transform: `rotate(${rotation}deg)`,
  transition: "transform 0.3s ease-in-out",
});

export default {
  customAvtar,
  multiSelectStyles,
  documentCardStyles,
  cropContainerStyle,
  rotationDisplayStyle,
  cropSourceStyle,
};